import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next';
import { HelmetProvider } from 'react-helmet-async';
import App from './App'
import './index.css'
import i18n from './i18n'

// --- VERIFICACIÓN DE DESPLIEGUE (SENIOR BUILD ENGINEER MODE) ---
// @ts-ignore
const buildTime = typeof __BUILD_TIMESTAMP__ !== 'undefined' ? __BUILD_TIMESTAMP__ : 'DEVELOPMENT_MODE';
// @ts-ignore
const commitHash = typeof __COMMIT_HASH__ !== 'undefined' ? __COMMIT_HASH__ : 'unknown';

console.log(`%c🚀 VOZFLOW DASHBOARD STARTUP`, 'color: #3b82f6; font-size: 14px; font-weight: bold;');
console.log(`%cBUILD_TIMESTAMP (STRICT): ${buildTime}`, 'color: #ef4444; font-size: 12px; font-weight: bold; background: #000; padding: 2px 5px;');
console.log(`%cCOMMIT_HASH: ${commitHash}`, 'color: #6b7280; font-size: 11px;');
console.log(`%cRUNTIME_CHECK: ${new Date().toISOString()}`, 'color: #10b981; font-size: 10px;');

try {
    // 2. Matar Service Workers (Solo si es necesario para actualización de assets)
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
            if (registrations.length > 0) {
                console.log(`💀 Se encontraron ${registrations.length} Service Workers. Eliminando para asegurar frescura...`);
                for (let registration of registrations) {
                    registration.unregister();
                }
            }
        });
    }
} catch (e) {
    console.error('Error durante la inicialización:', e);
}
// ---------------------------------------------

// Auto-verificación de versión para evitar cachés antiguas
fetch('/version.json?t=' + Date.now())
    .then(r => r.json())
    .then(v => {
        console.log('%c🚀 Versión Desplegada:', 'color: #3b82f6; font-weight: bold; font-size: 12px;', v.date);
        console.log('%cCache Status Check:', 'color: #10b981;', 'Solicitando datos frescos...');
    })
    .catch(() => console.log('No version info available'));

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <HelmetProvider>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </HelmetProvider>
    </React.StrictMode>,
)
